import Calendar from 'react-calendar';
import { useStatistics } from './StatiscticsContext';
import { autoComma, formatDateToKST } from '@/utils/parser';
import LayoutStatisticsCalendar from '@/components/dashboard/statistics-calendar/LayoutStatisticsCalendar';
import 'react-calendar/dist/Calendar.css';
import styles from './StatisticsCalendar.module.css';
import { cn } from '@/utils/tailwind';
import { useEffect } from 'react';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';
import { getStatisticsCalendarSelectedDate } from './statistics-calendar-selection';

const StatisticsCalendar = () => {
  const { calendarDailyList, selectedDate, setSelectedDate, activedMonthlySales } = useStatistics();
  const isPreviewMode = useMembershipPreviewMode();

  const todayStr = formatDateToKST(new Date()).slice(0, 10);
  const [todayYear, todayMonth] = todayStr.split('-').map(Number);

  const activeStartDate =
    activedMonthlySales && activedMonthlySales.Month
      ? new Date(activedMonthlySales.Month + '-01')
      : new Date(todayStr);

  const selectedDateObj = new Date(selectedDate);
  const handleCalendarDateSelect = (date: Date) => {
    setSelectedDate(getStatisticsCalendarSelectedDate(date));
  };

  useEffect(() => {
    if (!activedMonthlySales?.Month) return;

    const [year, month] = activedMonthlySales.Month.split('-').map(Number);
    const isCurrentMonth = year === todayYear && month === todayMonth;

    if (isCurrentMonth) {
      setSelectedDate(todayStr);
    } else {
      setSelectedDate(activedMonthlySales.Month + '-01');
    }
  }, [activedMonthlySales?.Month, setSelectedDate, todayMonth, todayStr, todayYear]);

  return (
    <LayoutStatisticsCalendar noLabel>
      {/* 래퍼 div에 고유 클래스 추가 */}
      <div
        className={`${styles['calendar-container']} statistics-calendar`}
        data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
      >
        <Calendar
          activeStartDate={activeStartDate}
          calendarType="gregory"
          value={selectedDateObj}
          showNavigation={false}
          onClickDay={handleCalendarDateSelect}
          onChange={(value) => {
            if (value && value instanceof Date) {
              handleCalendarDateSelect(value);
            }
          }}
          tileContent={({ date }) => {
            const day = date.getDate();
            const month = date.getMonth();
            const dateStr = formatDateToKST(date).slice(0, 10);
            const isToday = dateStr === todayStr;
            const isSelected = dateStr === selectedDate.slice(0, 10);
            // isFuture 변수 삭제

            const currentItem = calendarDailyList.find(
              (item) => item.Date.slice(0, 10) === dateStr,
            );
            const salesAmount = currentItem?.SalesAmount || 0;
            const settleCompletionAmount = currentItem?.SettleCompletionAmount || 0;
            const settleYetAmount = currentItem?.SettleYetAmount || 0;
            const settleTotalAmount = settleCompletionAmount + settleYetAmount;

            return (
              <div className="tile-content">
                <div
                  className={cn(
                    'day',
                    // isFuture ? 'future-day' :
                    isSelected ? 'selected' : isToday ? 'today' : '',
                    month !== new Date(activeStartDate).getMonth() && 'other-month',
                  )}
                >
                  {day}
                </div>
                {/* isFuture 조건 제거 */}
                {salesAmount > 0 && (
                  <div className={cn('salesAmount')}>{autoComma(salesAmount)}</div>
                )}
                {settleTotalAmount !== 0 && (
                  <div className={cn('settleAmount')}>{autoComma(settleTotalAmount)}</div>
                )}
              </div>
            );
          }}
        />
      </div>
    </LayoutStatisticsCalendar>
  );
};

export default StatisticsCalendar;
